<button
  class="chatbot-collapsed-button !p-[3rem]"
  mat-fab
  (click)="toggleChatDisplay()"
  [attr.aria-label]="isCollapsibleChatbotOpen() ? 'Collapse chatbot' : 'Open chatbot'"
  [attr.aria-expanded]="isCollapsibleChatbotOpen()"
  aria-controls="chatbot-container">
  
  @if(isCollapsibleChatbotOpen()) {
    <dsr-icon
    aria-hidden="true"
    name="cancel"
    size="45px"
    [@rotateAnimation]="iconState()"
    class="button-icon !rounded-full"
    color="white"
    ></dsr-icon>
  } @else {
    <div class="!size-[45px]">
      <img src="assets/images/artificial-intelligence-filled.svg" alt="AI chatbot icon" class="button-icon !rounded-full !size-[45px]">
    </div>
  }
</button>